import React from 'react'
import { CustomCellRendererProps } from 'ag-grid-react'
import { useUser } from 'view/hooks'
import { Locale, Translation } from '../../../../locale'

/** props.value has to be the id
 *  the Ag Grid column valueGetter has to point to it so
 * as an example: valueGetter: (params) => params.data.yourEntity.lastUpdatedBy
 * and then this component will manage retrieving the username from the store
 **/
export const UserNameRenderer = (props: CustomCellRendererProps) => {
  const user = useUser(props.value)

  return <span>{user?.username ?? Locale.translate(Translation.SC_SYSTEM)}</span>
}
